import { render, staticRenderFns } from "./IndexFormModal.vue?vue&type=template&id=23761856&"
import script from "./IndexFormModal.vue?vue&type=script&lang=js&"
export * from "./IndexFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports